function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["level"],
  _excluded2 = ["actions", "banner", "children", "className", "expandId", "heading", "initialIsOpen", "pills", "subtext", "assets"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { ChevronDown, ChevronRight } from '@procore/core-icons/dist';
import cx from 'classnames';
import React from 'react';
import { ulid } from 'ulid';
import { Button } from '../Button/Button';
import { getHeadingComponent } from '../Semantic/Semantic';
import { Title } from '../Title/Title';
import { sectionClassnames, StyledSection, StyledSectionBanner, StyledSectionCollapseHeading, StyledSectionContentRegion, StyledSectionHeader, StyledSectionInner, StyledTitle } from './Section.styles';
var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};

// Header levels start at level 2
export var LevelContext = /*#__PURE__*/React.createContext(2);
var SectionContext = /*#__PURE__*/React.createContext({
  open: {},
  setSection: function setSection() {},
  toggleSection: function toggleSection() {}
});
export function Heading(_ref) {
  var level_ = _ref.level,
    props = _objectWithoutProperties(_ref, _excluded);
  var level = React.useContext(LevelContext);
  var H = getHeadingComponent(level_ || level);
  return /*#__PURE__*/React.createElement(H, props);
}
export var SectionProvider = function SectionProvider(_ref2) {
  var children = _ref2.children;
  var _React$useState = React.useState({}),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setSectionsOpen = _React$useState2[1];
  var toggleSection = function toggleSection(id) {
    return setSectionsOpen(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, !prev[id]));
    });
  };
  var setSection = function setSection(id, open) {
    return setSectionsOpen(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, open));
    });
  };
  return /*#__PURE__*/React.createElement(SectionContext.Provider, {
    value: {
      open: open,
      toggleSection: toggleSection,
      setSection: setSection
    }
  }, children);
};
/**
 * @deprecatedSince 11
 * @deprecated Intended for internal library development. See Panel.Section or DetailPage.Section
 */
export var Section = /*#__PURE__*/React.forwardRef(function Section(_ref3, ref) {
  var actions = _ref3.actions,
    banner = _ref3.banner,
    children = _ref3.children,
    className = _ref3.className,
    expandId = _ref3.expandId,
    heading = _ref3.heading,
    _ref3$initialIsOpen = _ref3.initialIsOpen,
    initialIsOpen = _ref3$initialIsOpen === void 0 ? true : _ref3$initialIsOpen,
    pills = _ref3.pills,
    subtext = _ref3.subtext,
    assets = _ref3.assets,
    props = _objectWithoutProperties(_ref3, _excluded2);
  var level = React.useContext(LevelContext);
  var sections = React.useContext(SectionContext);
  var toggleOpen = React.useCallback(function () {
    if (expandId) {
      sections.toggleSection(expandId);
    }
  }, [expandId]);
  var open = expandId ? sections.open[expandId] : true;
  React.useEffect(function () {
    if (expandId && open === undefined) {
      sections.setSection(expandId, initialIsOpen);
    }
  }, []);
  var _React$useMemo = React.useMemo(function () {
      return {
        contentRegionId: "content-".concat(ulid()),
        headingTextId: "heading-".concat(ulid())
      };
    }, []),
    contentRegionId = _React$useMemo.contentRegionId,
    headingTextId = _React$useMemo.headingTextId;
  var expandClosed = !open || !children;
  var divide = level >= 3 || !heading;
  var hasHeader = heading || actions;
  return /*#__PURE__*/React.createElement(LevelContext.Provider, {
    value: level + 1
  }, /*#__PURE__*/React.createElement(StyledSection, _extends({
    ref: ref,
    className: cx(className, _defineProperty(_defineProperty(_defineProperty({}, sectionClassnames.divide, divide), sectionClassnames.levelAnonymous, !heading), sectionClassnames.level(level), heading && level))
  }, props), /*#__PURE__*/React.createElement(StyledSectionInner, null, banner && /*#__PURE__*/React.createElement(StyledSectionBanner, null, banner), hasHeader ? /*#__PURE__*/React.createElement(StyledSectionHeader, null, expandId ? /*#__PURE__*/React.createElement(StyledSectionCollapseHeading, {
    "aria-labelledby": headingTextId,
    "aria-level": level,
    role: "heading"
  }, /*#__PURE__*/React.createElement(Button, {
    "aria-controls": contentRegionId,
    "aria-expanded": open,
    "aria-labelledby": headingTextId,
    icon: open ? /*#__PURE__*/React.createElement(ChevronDown, null) : /*#__PURE__*/React.createElement(ChevronRight, null),
    onClick: toggleOpen,
    variant: "tertiary"
  })) : null, /*#__PURE__*/React.createElement(StyledTitle, null, /*#__PURE__*/React.createElement(Title.Text, null, heading && /*#__PURE__*/React.createElement(Heading, {
    "aria-hidden": expandId ? true : false,
    id: headingTextId
    // Pass level since Heading component renders
    // under the incremented (level + 1) LevelProvider.
    // Alternative, render Heading as a variable outside of return.
    ,
    level: level
  }, heading)), /*#__PURE__*/React.createElement(Title.Subtext, null, subtext), /*#__PURE__*/React.createElement(Title.Pills, null, pills), /*#__PURE__*/React.createElement(Title.Actions, null, isFunction(actions) ? actions({
    open: open
  }) : actions), /*#__PURE__*/React.createElement(Title.Assets, null, assets))) : null, /*#__PURE__*/React.createElement(StyledSectionContentRegion, {
    "aria-hidden": !open,
    "aria-labelledby": heading ? headingTextId : undefined,
    id: contentRegionId,
    role: "region",
    $closed: expandClosed,
    $noHeader: !hasHeader
  }, open ? children : null))));
});
Section.displayName = 'Section';
//# sourceMappingURL=Section.js.map